export const MODES = {
  INSERT: 'insert',
  RESULT: 'result',
};
